export default __webpack_public_path__ + "static/media/Thug's Armbands of Shattered Souls.af22b72d.jpg";